<template>
	<app-content class="h-panel">
		<Tabs :datas="tabDatas" v-model="selected"></Tabs>
		<div class="h-panel-body padding">
			<!-- 渲染当前路由匹配到的子页面。切换标签时路由变化，该区域内容随之更新 -->
			<router-view></router-view>
		</div>
	</app-content>
</template>
<script>
	/**
	 * 城市经理
	 * 容器页：顶部固定三个标签，通过 router-view 渲染对应的子页面
	 */
	export default {
		name: "CityManager",
		data() {
			return {
				// 当前选中的标签，其值即为子路由的 name
				selected: 'CityManagerList',
				// 固定的三个标签，key 与子路由 name 一一对应
				tabDatas: [{
					title: '城市经理',
					key: 'CityManagerList'
				}, {
					title: '部门归属',
					key: 'CityManagerDepartment'
				}, {
					title: '经营费用',
					key: 'CityManagerExpense'
				}]
			};
		},
		watch: {
			// 点击标签时跳转到对应的子路由
			selected(val) {
				this.$router.push({name: val}).catch(err => {});
			},
			// 通过菜单或浏览器前进/后退进入时，反向同步选中的标签
			$route() {
				this.syncSelected();
			}
		},
		mounted() {
			this.syncSelected();
		},
		methods: {
			/**
			 * 根据当前路由名同步选中的标签
			 * 仅当当前路由属于本容器的子标签时才同步，避免切换到其它页面时误改选中项
			 */
			syncSelected() {
				const name = this.$route.name;
				const matched = this.tabDatas.some(tab => tab.key === name);
				if (matched && name !== this.selected) {
					this.selected = name;
				}
			}
		}
	};
</script>
<style lang='less'>
	div.h-panel-bar {
		border-top: 0px solid #eeeeee
	}
</style>
